<style>
.table__btn--margin-left {
  margin-left: 22px;
}
* {
  font-size: 12px;
}
</style>

<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs6>
        <v-layout
          class="table--first-row"
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="show('taskCardModal')"
              class="table__btn--green"
            >add_circle</v-icon>
            <p
              class="caption"
              @click="addNewTask()"
            >DODAJ ZADANIE</p>

            <v-icon
              class="table__btn--blue table__btn--padding"
              style="padding-left: 25px;"
              v-show="selectedRow"
              @click="openCard"
            >note</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="openCard"
            >OTWÓRZ KARTĘ</p>

            <v-icon
              class="table__btn--red table__btn--padding"
              v-show="selectedRow"
              @click="removeRow"
            >delete</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="removeRow"
            >USUŃ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
              class="table__btn--blue"
            >cloud_download</v-icon>
            <p
              class="caption"
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
            >POBIERZ REJESTR</p>

            <v-icon
              class="table__btn--padding"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >zoom_in</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >PRZYBLIŻ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex
        xs6
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-select
            :items="task_typeDict"
            style="margin-right: 10px;"
            placeholder="Typ"
            :height="32"
            v-model="filterType"
            clearable
            persistent-hint
            filled
            @input="filterByProperty(filterType, 'task_type')"
          >
          </v-select>
          <v-select
            :items="statusDict"
            style="margin-right: 10px;"
            placeholder="Status"
            :height="32"
            v-model="filterStatus"
            clearable
            persistent-hint
            filled
            @input="filterByProperty(filterStatus, 'status')"
          >
          </v-select>
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    columnDefs: [],
    numberAll: '0',
    filter: "",
    numberFiltered: '0',
    selectedRow: undefined,
    tableTitle: "tasksTable",
    filterType: undefined,
    filterStatus: undefined,
    task_typeDict: undefined,
    statusDict: [],
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    getTasks() {
      return this.$store.getters.getTasks;
    },
    gridOptions() {
      let gridOptions = {
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        },
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        onGridReady: this.onGridReady,
        onFilterChanged: this.filteredNumber,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onSelectionChanged: this.onSelectionChanged,
        rowSelection: "single",
        rowData: this.loadData(),
      };
      return gridOptions;
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  beforeMount() {
    this.getDictValues("status")
    this.getDictValues("task_type")
    const formatDate = function (date, time) {
      if(date.value) {
        let options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }
        if(time) {
          options.hour = "2-digit"
          options.minute = "2-digit"
        }
        return new Date(date.value).toLocaleString("pl-PL", options);
      } else {
        return null
      }
    }
    //Funkcja porównująca daty (splitujemy string, tworzymy obiekt daty, która leci do porównania)
    const compareDate = function (filterLocalDateAtMidnight, cellValue) {
      if(!cellValue) return 0
      let date = new Date(cellValue);
      let dateString;
      let timeString;
      if(cellValue.includes('T')) {
        [dateString, timeString] = cellValue.split('T');
      } else {
        [dateString, timeString] = cellValue.split(' ');
      }
      var dateStringParts = dateString.split("-");
      // let timeStringParts = timeString.split(':')
      var day = Number(dateStringParts[2]);
      var month = Number(dateStringParts[1]) - 1;
      var year = Number(dateStringParts[0]);
      // TODO spróbować naprawić godziny i minuty
      // let hours = Number(timeStringParts[0])
      // let minutes = Number(timeStringParts[1])
      var cellDate = new Date(year, month, day);
      if(cellDate < filterLocalDateAtMidnight) {
        return -1;
      } else if(cellDate > filterLocalDateAtMidnight) {
        return 1;
      } else {
        return 0;
      }
    }
    const compareText = function (valueA, valueB, nodeA, nodeB) {
      const a = valueA || ""
      const b = valueB || ""
      return a.toLowerCase().localeCompare(b.toLowerCase());
    }
    const reportedOperatorName = function (reported_operator) {
      return this.users.find(user => user.id === reported_operator.value)
    }
    this.columnDefs = [
      {
        headerName: "ID",
        field: "id",
        sort: "asc",
        width: 50
      },
      {
        headerName: "FID",
        field: "fid",
      },
      {
        headerName: "Przyczyny",
        field: "damage_causes",
        valueGetter: val => {
          return val.data.damage_causes.join(", ")
        }
      },
      {
        headerName: "Adres",
        field: "address"
      },
      {
        headerName: "Przypisani pracownicy",
        field: "users",
        valueGetter: val => {
          return val.data.users.map(user => user.name).join(", ")
        }
      },
      {
        headerName: "Typ uszkodzenia",
        field: "damage_type"
      },
      {
        headerName: "Opis",
        field: "description"
      },
      {
        headerName: "Opis lokalizacji",
        field: "localization_description"
      },
      {
        headerName: "Typ lokalizacji",
        field: "localization_type"
      },
      {
        headerName: "Wiadomość dla ekipy",
        field: "message"
      },
      {
        headerName: "Rodzaj sieci",
        field: "net_kind"
      },
      {
        headerName: "Typ sieci",
        field: "net_type"
      },
      {
        headerName: "Działka",
        field: "parcel"
      },
      {
        headerName: "Opis zgłoszenia",
        field: "report_description",
        comparator: (valueA, valueB, nodeA, nodeB) => compareText(valueA, valueB, nodeA, nodeB)
      },
      {
        headerName: "Adres zgłaszającego",
        field: "reported_by_address"
      },
      {
        headerName: "Email zgłaszającego",
        field: "reported_by_email"
      },
      {
        headerName: "Imię i nazwisko",
        field: "reported_by_name",
        comparator: (valueA, valueB, nodeA, nodeB) => compareText(valueA, valueB, nodeA, nodeB)
      },
      {
        headerName: "Telefon zgłaszającego",
        field: "reported_by_phone"
      },
      {
        headerName: "Przyjmujący zgłoszenie",
        field: "reported_operator",
        valueGetter: val => {
          return val.data.reported_operator.name
        }
      },
      {
        headerName: "Status",
        field: "status"
      },
      {
        headerName: "Typ zadania",
        field: "task_type",
        comparator: (valueA, valueB, nodeA, nodeB) => compareText(valueA, valueB, nodeA, nodeB)
      },
      {
        headerName: "Utworzono",
        field: "created_time",
        cellRenderer: date => formatDate(date),
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) => compareDate(filterLocalDateAtMidnight, cellValue),
          browserDatePicker: true
        },
      },
      {
        headerName: "Data zgłoszenia",
        field: "reported_at_datetime",
        cellRenderer: date => formatDate(date, true),
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) => compareDate(filterLocalDateAtMidnight, cellValue),
          browserDatePicker: true
        },
      },
      {
        headerName: "Data rozpoczęcia",
        field: "start_time",
        cellRenderer: date => formatDate(date, true),
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) => compareDate(filterLocalDateAtMidnight, cellValue),
          browserDatePicker: true
        },
      },
      {
        headerName: "Data zakończenia",
        field: "end_time",
        cellRenderer: date => formatDate(date, true),
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) => compareDate(filterLocalDateAtMidnight, cellValue),
          browserDatePicker: true
        },
      },
    ]
  },
  methods: {
    addNewTask() {
      this.$root.$emit("addNewTask")
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    filterByProperty(value, property) {
      const filterInstance = this.gridOptions.api.getFilterInstance(
        property
      );
      filterInstance.setModel({
        type: "equals",
        filter: value
      });
      this.gridOptions.api.onFilterChanged();
      this.filteredNumber();
    },
    getDictValues(field) {
      let payload = {
        schema: "registry",
        table: "tasks",
        column: field
      };
      this.$store.dispatch("getDictSTC", payload).then(r => {
        if(!r) {
          return;
        } else {
          this[field + 'Dict'] = r.values;
        }
      });
    },
    loadData() {
      this.$store.dispatch("getTasks", {materials: true}).then(success => {
        this.numberAll = this.getTasks.tasks.length;
        this.numberFiltered = this.numberAll;
        this.gridOptions.api.setRowData(
          this.$store.getters.getTasks.tasks
        );
      });
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(this.gridOptions.columnApi.getColumnState());
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    },
    openCard() {
      let payload = {
        object_id: this.selectedRow.id,
        object_type: "tasks",
        limit: 5,
        events_count: true
      };
      this.$store.dispatch("getFeatureEvents", payload).then(success => {
        if(success) {
          this.$root.$emit('loadTaskData', this.selectedRow, true);
          this.show("taskCardModal");
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania danych zadania wystąpił błąd"
          );
        }
      });
    },
    removeRow() {
      const id = this.selectedRow.id;
      this.$emit("confDialogOpened", true);
      this.$modal.show("dialog", {
        title: "Usuwanie zadania",
        text: "Czy na pewno chcesz usunąć zadanie?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              this.$store.dispatch("deleteTask", id).then(success => {
                if(success) {
                  this.loadData();
                } else {
                  this.$root.$emit(
                    "showSnackbar",
                    "red",
                    "Podczas usuwania zadania wystąpił błąd"
                  );
                }
              });
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    zoomToGeometry() {
      this.$root.$emit("removeObjectArea");
      this.$root.$emit("addObjectArea", this.selectedRow);
      this.$root.$emit("zoomToArea", [
        this.selectedRow.geometry.coordinates
      ]);
    }
  },
  mounted() {
    this.$root.$on("updateTaskTable", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/TasksTable.vue